
import { initializeApp } from "firebase/app";

export const BRANDNAME = "Global Finance";

export const TransactionStatus = {
    PENDING: 0,
    CONFIRMED: 1,
    CANCELLED: 2,
}

export const plans = [ 
    {
      name: "Plan 1",
      min: 200,
      max: 1999,
      duration: "6 days",
      Profits: 12,
      referralCommission: 5,
      days: 6,
      id: 0,
    },
    {
      name: "Plan 2",
      min: 2000,
      max: 29999,
      duration: "6 days",
      Profits: 18,
      referralCommission: 5,
      days: 6,
      id: 1,
    },
    {
      name: "Plan 3",
      min: 30000,
      max: 999999,
      duration: "6 days",
      Profits: 24,
      referralCommission: 5,
      days: 6,
      id: 2,
    },
    {
      name: "Plan 4",
      min: 100000,
      max: Number.POSITIVE_INFINITY,
      duration: "6 days",
      Profits: 30,
      referralCommission: 5,
      days: 6,
      id: 3,
    },
  ];
  
export const planx = [ 
    {
      name: "Plan 1",
      min: 200,
      max: 1999,
      duration: "6 days",
      Profits: 12,
      referralCommission: 5,
      days: 6,
      id: 0,
    },
    {
      name: "Plan 2",
      min: 2000,
      max: 29999,
      duration: "6 days",
      Profits: 18,
      referralCommission: 5,
      days: 6,
      id: 1,
    },
    {
      name: "Plan 3",
      min: 30000,
      max: 999999,
      duration: "6 days",
      Profits: 24,
      referralCommission: 5,
      days: 6,
      id: 2,
    },
    {
      name: "Plan 4",
      min: 100000,
      max: Number.POSITIVE_INFINITY,
      duration: "6 days",
      Profits: 30,
      referralCommission: 5,
      days: 6,
      id: 3,
    },
  ];
  
export const emptyPlan = {
    name: "none",
    min: 0,
    max: 0,
    duration: "0 days",
    Profits: 0,
    referralCommission: 0,
    days: 0,
    amount: 0,
    id: 8230,
  }

  const firebaseConfig = {
    apiKey: "AIzaSyBgqK3BZPIj9pQwzKvtnlqBKRjRLs9TJO4",
    authDomain: "globalfinancez.firebaseapp.com",
    projectId: "globalfinancez",
    storageBucket: "globalfinancez.appspot.com",
    messagingSenderId: "195513769792",
    appId: "1:195513769792:web:144a845d63c959498d24a5"
  };

  // Initialize Firebase
initializeApp(firebaseConfig);
export function FireApp() {
 
}


  class Coin{
    constructor(name, symbol, address){
        this.name = name;
        this.symbol = symbol;
        this.address = address;
        this.price = 0;
    }
    static emtpy(){
        return new Coin("", "", "");
    }
}

const n = ["binancecoin","bitcoin","litecoin","tron","ethereum","binancecoin"];
const s = ["BNB(bep20)","BTC","LTC","TRX","ETH", "BNB"];
const a = [
"0x66C08B3f9d120a4B583Ddd308E4F5b719e52Eb3F",
"bc1qecn2uuvzmhnd58zqx9f6495vhppddlc95zzgjq",
"ltc1qlt0t20ud456a0kdyhqzwpek854uv5wxjcsvysu",
"TP5Y4ZqAtuqJ8gx3rg8RTL5LEST96XP9zo",
"0x66C08B3f9d120a4B583Ddd308E4F5b719e52Eb3F",
"bnb1ku8zzpa9eqkghekq3xth709uypshswqnxnwcfh"
];

function getCoins(prices){
    let coins = [];
    for(let i = 0; i < n.length; i++){
        const c = new Coin(n[i], s[i], a[i]);
        c.price = prices[n[i]].usd
        if(s[i] == "BNB(bep20)"){
            c.name = "binancecoin(bep20)";
        }
        coins.push(c);
    }
    var usdt = new Coin("tether(bep20)", "USDT(bep20)", "0x66C08B3f9d120a4B583Ddd308E4F5b719e52Eb3F");
    usdt.price = 1;
    coins.push(usdt);
    var usdt2 = new Coin("tether(trc20)", "USDT(trc20)", "TP5Y4ZqAtuqJ8gx3rg8RTL5LEST96XP9zo");
    usdt2.price = 1;
    coins.push(usdt2);
    var usdt3 = new Coin("tether(erc20)", "USDT(erc20)", "0x66C08B3f9d120a4B583Ddd308E4F5b719e52Eb3F");
    usdt3.price = 1;
    coins.push(usdt3);
    coins.sort((a, b) => (a.symbol < b.symbol) ? 1 : -1);
    return coins;
}

export {Coin, getCoins};
